<div class="flxClmn bs-enabled">
	<div class="page-title-container flxRow" *ngIf="!isEmbedded">
		<div class="flxClmn-center f-1-0">
			<div class="page-title-inner-container flxRow">
				<span class="page-title">Look and Feel</span>
				<more-info-c>
					<div class="flxClmn vSpace05" style="flex: 1 0;">
						<span style="font-weight: bold;">Email template customization</span>
						<br/>
						<ul class="vSpace1" style="margin-top: 0;">
							<li style="color:#484848;"><span>Each part of the encrypted email template can be customized</span></li>
							<li style="color:#484848;"><span>Logo image may be in PNG format only and up to 200KB in size</span></li>
							<li style="color:#484848;"><span>For the email headline and footer you may use any combination of text, HTML, and dynamic fields</span></li>
							<li style="color:#484848;"><span>Manual token input: when enabled, the template will contain instructions on how to access encrypted emails manually using the encrypted token</span></li>
						</ul>
					</div>
					<div class="flxClmn vSpace05" style="flex: 1 0;">
						<span style="font-weight: bold;">Apply your own Look and Feel</span>
						<br/>
						<ul class="vSpace1" style="margin-top: 0;">
							<li style="color:#484848;"><span>You may add your company's name and URL to automatically add these values to your email templates</span></li>
							<li style="color:#484848;"><span>When this is enabled, your logo and color customizations will apply also to the admin portal and to the encrypted email portal</span></li>
						</ul>
					</div>
				</more-info-c>
			</div>
			<div class="page-subtitle-container">
				<span class="page-subtitle">Your logo, name and brand color across {{corpname}}</span>
			</div>
		</div>
		<div class="control-and-info-icons flxRow"></div>
	</div>

	<div class="page-inner-content-holder no-scroll flex-column">
		<div class="flex-column f-1-0 overflow-auto gap-1">
			<!--Top bar: preset controls + Save/Cancel-->
			<div class="flex-row align-items-center justify-content-between gap-3 p-3 flex-wrap bg-light" style="z-index: 50;"
				 *ngIf="!isEmbedded">

				<!--Left: existing preset controls-->
				<div class="flex-row align-items-center gap-2 animated fadeIn"
					 *ngIf="!addCustomizationInProcess && mySettingsLogo?.selectedCustomization">
					<div class="flex-row align-items-baseline gap-1">
						<span>Customization preset:</span>
						<i class="far fa-question-circle"
						   tooltip='The "Main" customization will be used by default. You can add more customizations that can be applied according to rules'
						   placement="top"></i>
					</div>
					<app-dropdown-c style="width: 175px; height: 32px;" [showTitle]="true"
									text="{{mySettingsLogo.selectedCustomization.name}}">
						<li *ngFor="let subCustomization of mySettingsLogo.sub_customizations"
							(click)="selectSubCustomization(subCustomization);">
							{{subCustomization.name}}
						</li>
					</app-dropdown-c>
					<btn-c class="bg-white" style="min-width: 0;"
						   btnTooltip="Add new customization preset"
						   variant="outlined" endIcon="far fa-plus"
						   (action)="addSubCustomization();">
						Add
					</btn-c>
					<btn-c class="animated fadeIn bg-white"
						   *ngIf="mySettingsLogo.selectedCustomization.name === dic.CONSTANTS.lfMainCustomizationName"
						   btnTooltip='Reset "Main" preset to default settings'
						   variant="outlined" color="warning"
						   (action)="openDeleteLogoPopup();">
						Reset to Default
					</btn-c>
					<btn-c class="animated fadeIn bg-white"
						   *ngIf="mySettingsLogo.selectedCustomization.name !== dic.CONSTANTS.lfMainCustomizationName"
						   variant="outlined" color="danger"
						   (action)="deleteSubCustomization();">
						Delete preset
					</btn-c>
				</div>

				<!--Left: new customization name input-->
				<div class="flex-row align-items-center gap-2 animated fadeIn" *ngIf="addCustomizationInProcess">
					<span>New customization's name:</span>
					<input type="text" placeholder="Name" style="width: 180px; margin: 0;"
						   [(ngModel)]="mySettingsLogo.selectedCustomization.name"/>
					<btn-c class="bg-white" variant="outlined" (action)="cancelSubCustomization();">Cancel</btn-c>
				</div>

				<!--Right: Cancel Changes + Save-->
				<div class="flex-row align-items-center gap-2">
					<btn-c class="bg-white" variant="outlined"
						   [isDisabled]="userLogoDiff || updateLfInProcess"
						   *ngIf="!addCustomizationInProcess"
						   (action)="cancelChanges();">
						Cancel Changes
					</btn-c>
					<btn-c [isDisabled]="userLogoDiff"
						   [loading]="updateLfInProcess"
						   *ngIf="!addCustomizationInProcess"
						   (action)="openUpdateLogoDetailsPopup(); wasSubmitted = true;">
						Save
					</btn-c>
					<btn-c [isDisabled]="saveSubCustomizationDisabled()"
						   *ngIf="addCustomizationInProcess"
						   (action)="saveSubCustomization(false); wasSubmitted = true;">
						Save
					</btn-c>
				</div>
			</div>

			<!--Main area: tabs + settings | email preview-->
			<div class="flex-row f-1-0 overflow-hidden">

				<!--Left: tabs + settings content-->
				<div class="flex-column f-1-0 overflow-auto">

					<!--Tabs-->
					<div class="md-tabs">
						<div *ngFor="let tabEntry of tabs | keyvalue: gs.returnZero; let tabIdx = index"
							 class="border border-bottom-0"
							 [ngClass]="{'selected': activeTab === tabEntry.value}"
							 [style.width]="(100 / _.size(tabs)) + '%'"
							 (click)="activeTab = tabEntry.value;">
							<input type="radio" name="tabs" id="{{tabEntry.value.label}}Toggle" [checked]="activeTab === tabEntry.value">
							<label for="{{tabEntry.value.label}}Toggle" class="flex-row align-items-center gap-2 w-100">
								<i class="{{tabEntry.value.icon}}"></i>
								<span>{{tabEntry.value.label}}</span>
							</label>
						</div>
						<div class="slide" [style.width]="(100 / _.size(tabs)) + '%'" [style.left]="(_.values(tabs).indexOf(activeTab) * 100 / _.size(tabs)) + '%'"></div>
					</div>

					<!--Settings content-->
					<div class="flex-column overflow-auto p-3 ps-0">

						<!--BRAND TAB-->
						<div class="list-group list-group-flush settings-list-container animated fadeIn"
							 *ngIf="activeTab === tabs.brand">

							<!--Logo-->
							<div class="list-group-item settings-list-item column-style gap-3 py-2">
								<div class="title-section-container flex-column gap-2">
									<b>Logo</b>
									<span class="lh-base" style="font-size: 0.9em;">Visible at the top of all outbound secure emails.</span>
								</div>
								<div class="content-container flex-row gap-3 align-items-center" *ngIf="mySettingsLogo?.selectedCustomization">
									<!--Upload box-->
									<a ngfSelect accept=".png"
									   [(file)]="logoFile"
									   (fileChange)="uploadLogo()"
									   class="flex-column bg-light align-items-center justify-content-center gap-2 border rounded-2 position-relative"
									   style="width: 300px; height: 115px; cursor: pointer; text-decoration: none; --bs-border-style: dashed; font-size 15px;">
										<img [src]="'data:image/png;base64,' + mySettingsLogo.selectedCustomization.logo"
											 style="max-width: 80%; max-height: 50px; height: auto;"
											 *ngIf="mySettingsLogo.selectedCustomization.logo" />
										<i *ngIf="!mySettingsLogo.selectedCustomization.logo"
										   class="far fa-cloud-upload text-muted" style="font-size: 1.8rem;"></i>
										<span class="a-link" style="font-size: 0.85em;">
											{{mySettingsLogo.selectedCustomization.logo ? 'Change logo' : 'Click to upload'}}
										</span>
										<span class="text-muted text-center" style="font-size: 0.75em; padding: 0 8px;">PNG only, optimal size: 275×50px</span>
										<i *ngIf="mySettingsLogo.selectedCustomization.logo"
										   (click)="$event.stopPropagation(); mySettingsLogo.selectedCustomization.logo = null; initChanges(true);"
										   class="far fa-times"
										   style="position: absolute; top: 5px; right: 6px; font-size: 0.85rem;"></i>
									</a>

									<div class="vertical-separator opacity-25"></div>

									<!--Logo size-->
									<div class="flex-column gap-3 bs-enabled">
										<span class="fw-bold mb-2">Logo size</span>
										<label class="radio-container m-0 ps-4" style="display: block;">
											Medium
											<input type="radio" name="logoSizeInput"
												   [(ngModel)]="mySettingsLogo.selectedCustomization.logo_template_size"
												   (ngModelChange)="initChanges(true);"
												   [value]="logoSizes.medium">
											<span class="checkmark"></span>
										</label>
										<label class="radio-container m-0 ps-4" style="display: block;">
											Large
											<input type="radio" name="logoSizeInput"
												   [(ngModel)]="mySettingsLogo.selectedCustomization.logo_template_size"
												   (ngModelChange)="initChanges(true);"
												   [value]="logoSizes.large">
											<span class="checkmark"></span>
										</label>
									</div>
								</div>
							</div>

							<!--Theme color-->
							<div class="list-group-item settings-list-item column-style gap-3 py-3">
								<div class="title-section-container flex-column gap-2">
									<b>Theme color</b>
									<span class="lh-base" style="font-size: 0.9em;">Used for buttons, links, and accents across the platform, and encrypted email button</span>
								</div>
								<div class="content-container flex-row mx-auto gap-5 align-items-center color-picker-css"
									 *ngIf="mySettingsLogo?.selectedCustomization">
									<div class="flex-column align-items-center gap-2">
										<div style="width: 50px; height: 50px; border-radius: 50%;"
											 [ngStyle]="{'background': '#' + mySettingsLogo.selectedCustomization.color.replace('#','')}"
											 *ngIf="mySettingsLogo.selectedCustomization.color?.replace('#','').length === 6"></div>
										<input type="text" style="width: 110px; margin: 0; text-align: center;"
											   [(ngModel)]="mySettingsLogo.selectedCustomization.color"
											   [ngClass]="{'validation-error': hexInputError}"
											   (keyup)="hexInputChanged();"
											   [value]="'#' + mySettingsLogo.selectedCustomization.color.replace('#','')">
										<span class="text-muted" style="font-size: 0.8em;">6-digit color hex</span>
									</div>
									<span [(colorPicker)]="mySettingsLogo.selectedCustomization.color"
										  [cpPosition]="'bottom'" [cpPositionOffset]="'50%'" [cpWidth]="'145px'"
										  [cpOutputFormat]="'hex'"
										  [cpDialogDisplay]="'inline'"
										  [cpDisableInput]="true"
										  [cpToggle]="true"
										  (cpSliderDragEnd)="colorChangedHandler()"
										  [style.position]="'relative'"></span>
								</div>
							</div>

							<!--Customized environment-->
							<div class="list-group-item settings-list-item column-style gap-3 py-3">
								<div class="title-section-container flex-column gap-2">
									<b>Customized environment</b>
									<span class="lh-base" style="font-size: 0.9em;">Apply your custom settings to Trustifi's web application, encrypted email portal and notification emails</span>
								</div>
								<div class="content-container flex-row align-items-center gap-4">
									<checkbox id="environmentLF"
											  *ngIf="(mySettingsLogo?.selectedCustomization?.name === dic.CONSTANTS.lfMainCustomizationName) && mySettingsLogo?.lf"
											  [(model)]="mySettingsLogo.lf.enabled"
											  (modelChange)="initChanges()">
										Enable customized environment
									</checkbox>
									<div class="flex-column gap-2"
										 [ngClass]="{'disabled': mySettingsLogo?.selectedCustomization?.name === dic.CONSTANTS.lfMainCustomizationName && !mySettingsLogo?.lf?.enabled}"
										 [tooltip]="(mySettingsLogo?.selectedCustomization?.name === dic.CONSTANTS.lfMainCustomizationName && !mySettingsLogo?.lf?.enabled) ? 'Enable the customized environment first' : ''"
										 placement="top">
										<div class="flex-row align-items-center gap-2"
											 *ngIf="mySettingsLogo?.lf && mySettingsLogo?.selectedCustomization">
											<span style="flex-basis: 45px; flex-shrink: 0;">Name:</span>
											<input type="text" style="margin: 0; width: 220px;"
												   *ngIf="mySettingsLogo.selectedCustomization.name === dic.CONSTANTS.lfMainCustomizationName"
												   [(ngModel)]="mySettingsLogo.lf.company"
												   (ngModelChange)="initChanges();"
												   placeholder="Company name"
												   [disabled]="!mySettingsLogo?.lf?.enabled"
												   [ngClass]="{'validation-error': wasSubmitted && mySettingsLogo.lf.enabled && !mySettingsLogo.lf.company}">
											<input type="text" style="margin: 0; width: 220px;"
												   *ngIf="mySettingsLogo.selectedCustomization.name !== dic.CONSTANTS.lfMainCustomizationName"
												   [(ngModel)]="mySettingsLogo.selectedCustomization.company"
												   (ngModelChange)="initChanges();"
												   placeholder="Company name (optional)">
										</div>
										<div class="flex-row align-items-center gap-2"
											 *ngIf="(mySettingsLogo?.selectedCustomization?.name === dic.CONSTANTS.lfMainCustomizationName) && mySettingsLogo?.lf">
											<span style="flex-basis: 45px; flex-shrink: 0;">URL:</span>
											<input type="text" style="margin: 0; width: 220px;"
												   [(ngModel)]="mySettingsLogo.lf.url"
												   (ngModelChange)="initChanges();"
												   placeholder="Company's URL"
												   [disabled]="!mySettingsLogo?.lf?.enabled"
												   [ngClass]="{'validation-error': wasSubmitted && mySettingsLogo.lf.enabled && !mySettingsLogo.lf.url}">
										</div>
									</div>
								</div>
							</div>
						</div>

						<!--EMAIL TEMPLATE TAB-->
						<div class="list-group list-group-flush settings-list-container animated fadeIn"
							 *ngIf="activeTab === tabs.emailTemplate">

							<!--Enable email template-->
							<div class="list-group-item settings-list-item column-style gap-3 py-3"
								 *ngIf="(mySettingsLogo?.selectedCustomization?.name === dic.CONSTANTS.lfMainCustomizationName) && mySettingsLogo?.lf">
								<div class="title-section-container flex-column gap-2">
									<b>Outbound email template</b>
									<span class="lh-base" style="font-size: 0.9em;">Apply your logo, theme color, and custom HTML to all outgoing Trustifi encrypted emails</span>
								</div>
								<div class="content-container">
									<checkbox id="emailTemplate"
											  [(model)]="mySettingsLogo.lf.template_enabled"
											  (modelChange)="initChanges('force')">
										Enable outbound email template
									</checkbox>
								</div>
							</div>

							<!--Email template HTML-->
							<div class="list-group-item settings-list-item column-style gap-3 py-3">
								<div class="title-section-container flex-column gap-2">
									<b>Email template HTML</b>
									<span class="lh-base" style="font-size: 0.9em;">Customize the header and footer of your encrypted email using HTML</span>
								</div>
								<div class="content-container flex-column gap-3">
									<div class="flex-column gap-2">
										<span class="fw-500">Customized header</span>
										<textarea style="resize: vertical; height: 85px; width: 100%; margin: 0;"
												  placeholder="Insert HTML code here"
												  [(ngModel)]="mySettingsLogo.selectedCustomization.headline"
												  (ngModelChange)="initChanges();"
												  (blur)="initChanges(true);"></textarea>
										<div class="flex-row align-items-center gap-2 animated fadeIn" *ngIf="headlineError">
											<span class="text-danger" style="font-size: 0.85em;">Header HTML invalid</span>
											<btn-c variant="outlined" endIcon="fa fa-magic"
												   (action)="fixHtmlCode(dic.CONSTANTS.lfCustomHtmlScopes.header);">
												Fix code
											</btn-c>
										</div>
									</div>
									<div class="flex-column gap-2">
										<span class="fw-500">Customized footer</span>
										<textarea style="resize: vertical; height: 85px; width: 100%; margin: 0;"
												  placeholder="Insert HTML code here"
												  [(ngModel)]="mySettingsLogo.selectedCustomization.footer"
												  (ngModelChange)="initChanges();"
												  (blur)="initChanges(true);"></textarea>
										<div class="flex-row align-items-center gap-2 animated fadeIn" *ngIf="footerError">
											<span class="text-danger" style="font-size: 0.85em;">Footer HTML invalid</span>
											<btn-c variant="outlined" endIcon="fa fa-magic"
												   (action)="fixHtmlCode(dic.CONSTANTS.lfCustomHtmlScopes.footer);">
												Fix code
											</btn-c>
										</div>
									</div>
								</div>
							</div>

							<!--Decryption button & token input-->
							<div class="list-group-item settings-list-item column-style gap-3 py-3">
								<div class="title-section-container flex-column gap-2">
									<b>Decryption button & token input</b>
								</div>
								<div class="content-container flex-column gap-3">
									<div class="flex-row align-items-center gap-2">
										<span style="flex-shrink: 0;">Custom button text:</span>
										<input type="text" style="margin: 0; width: 220px;"
											   placeholder="(optional)"
											   [(ngModel)]="mySettingsLogo.selectedCustomization.template_btn_name"
											   (ngModelChange)="mySettingsLogo.selectedCustomization.template_btn_name_enabled = !!$event; initChanges(true);">
									</div>
									<checkbox id="template_always_emphasize"
											  tooltipTxt="The button to decrypt the email or attachments will always be placed at the top of the email body"
											  tooltipDirection="right"
											  [(model)]="mySettingsLogo.selectedCustomization.template_always_emphasize"
											  (modelChange)="initChanges(true)">
										Always place decryption button on top of email content
									</checkbox>
									<checkbox id="encToken"
											  tooltipTxt="When checked, the encrypted email will include instructions for manually accessing it using the encrypted token"
											  tooltipDirection="right"
											  *ngIf="mySettingsLogo?.selectedCustomization"
											  [model]="mySettingsLogo.selectedCustomization.show_enc_help"
											  (modelChange)="mySettingsLogo.selectedCustomization.show_enc_help = $event; initChanges(true)">
										Show manual token input
									</checkbox>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!--Right: Email Preview-->
				<div class="flex-column f-1-0 border-start bg-light gap-3 py-3 px-4">
					<div class="flex-row align-items-center justify-content-between">
						<span class="fw-bold text-uppercase" style="font-size: 0.9rem;">Email Preview</span>
						<div class="flex-row align-items-center gap-2 animated fadeIn"
							 *ngIf="mySettingsLogo?.lf && !mySettingsLogo.lf.template_enabled">
							<i class="far fa-hand-back-point-right"></i>
							<span><a class="blue-link text-decoration-underline" (click)="mySettingsLogo.lf.template_enabled = true; initChanges(true); activeTab = tabs.emailTemplate;">Enable the email template</a> to see the preview</span>
						</div>

					</div>
					<div class="flex-column f-1-0 bg-white border rounded-3 position-relative" style="overflow: auto; padding: 1vw;">
						<email-viewer [content]="previewEmailContent" [prioritizeClasses]="true" style="min-height: 100%;"></email-viewer>
						<div class="flex-column align-items-center justify-content-center animated fadeIn"
							 style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: rgba(255,255,255,0.7);"
							 *ngIf="previewEmailInProgress">
							<loader height="100" width="100" style="opacity: 0.8;"></loader>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>


</div>
